import ViewListIcon from "@material-ui/icons/ViewList";
import { ordersResource } from "../orders";
import { tasksResource } from "../tasks";
import { EntitiesList } from "./List/List";
import React from "react";
import { EntityType, resourceByEntityType } from "../../entities/EntityType";
import { useGetOne } from "react-admin";


const EntitiesAction = (_props) => {
	const props = {..._props};

	let action = "edit";
	let entityId = props.id;
	if (props.location.pathname.indexOf("/show") !== -1) {
		action = "show";
	} else if (props.location.pathname.indexOf("/create") !== -1) {
		action = "create";
		const sourceObject = JSON.parse(decodeURIComponent(new URLSearchParams(props.location.search).get('source')));
		entityId = sourceObject.origin_id;
	};

	const { data: record, loading } = useGetOne(_props.resource, entityId);

	if (loading) return null;

	props.resource = resourceByEntityType[record.type];
	props.title = `resources.${_props.resource}.name`;

	if (record.type === EntityType.order) {
		return React.createElement(ordersResource[action], props);
	} else if (record.type === EntityType.task) {
		return React.createElement(tasksResource[action], props);
	};

	return null;
};


export const commonEntitiesResource = {
	list: EntitiesList,
	icon: ViewListIcon,

}
export const entitiesResource = {
	...commonEntitiesResource,
	edit: EntitiesAction,
	create: EntitiesAction,
	show: EntitiesAction,
};

// export const PermissionWrapper = ({ children }) => {
// 	const { permissions } = usePermissions();
// 	return React.cloneElement(children, { permissions: permissions });
// };

// export const createEntityRoute = (
// 	resource,
// 	Component,
// 	action = "edit",
// 	usePermissionsWrapper = false,
// 	exact = true
// ) => {
// 	const pathSuffix = action === "show" ? "/show" : "";

// 	const RenderComponent = ({ match }) => {
// 		const componentToRender = (
// 			<Component id={match.params.id} basePath="/entities" resource={resource} />
// 		);

// 		return usePermissionsWrapper ? (
// 			<PermissionWrapper>{componentToRender}</PermissionWrapper>
// 		) : (
// 			componentToRender
// 		);
// 	};

// 	return (
// 		<Route
// 			key={`${resource}-${action}`}
// 			exact={exact}
// 			path={`/entities/${resource}/:id${pathSuffix}`}
// 			render={RenderComponent}
// 		/>
// 	);
// };

// export const getEntitiesRouts = ({
// 	taskEdit: TaskEditComponent = TaskEdit,
// 	orderEdit: OrderEditComponent = OrderEditByManager,
// 	taskShow: TaskShowComponent = TaskShowTabsWrapper,
// 	orderShow: OrderShowComponent = OrderShowTabsWrapper,
// } = {}) => [
// 	createEntityRoute("tasks", TaskEditComponent),
// 	createEntityRoute("orders", OrderEditComponent),
// 	createEntityRoute("tasks", TaskShowComponent, "show", true, false),
// 	createEntityRoute("orders", OrderShowComponent, "show", true, false),
// ];

// export const entitiesRouts = getEntitiesRouts();
